import { FC } from "react";

import { DarkSection } from "../../components/DarkSection";

export const AboutHero: FC = () => {
  return (
    <>
      <DarkSection className="grid grid-cols-[auto_minmax(0,86rem)_auto] grid-rows-[76px_auto]">
        <div className="">{/* empty */}</div>
        <div className="dotted-v lg:mx-12 lg:border-x">{/* empty */}</div>
        <div className="">{/* empty */}</div>
        <div className="">{/* empty */}</div>
        <div className="dotted-v flex min-h-[400px] items-center justify-start lg:mx-12 lg:border-x">
          <div className="flex w-full flex-col items-start gap-6 px-6 py-14 lg:flex-row lg:items-center lg:p-14">
            <h1 className="text-frecWhite text-[32px] lg:text-[50px]">
              Frec creates
              <br />
              <span className="text-frecNeon">new opportunities</span>
              <br /> for your wealth.
            </h1>
            <article className="mx-auto flex max-w-full flex-col gap-8 opacity-80 lg:max-w-xl">
              <p className="text-frecWhite">
                Money is deeply personal. Yet, it’s a topic that most people
                only understand on the surface level. Beyond that opaque
                surface, there is a hidden world of sophisticated financial
                strategies, gate kept behind the walls of institutional banks
                and only accessible through wealth managers.
              </p>
              <p className="text-frecWhite">
                With modern day technology, financial control is shifting to the
                hands of everyday investors like you. Frec exists to enable that
                shift and give everyone the chance to create new opportunities
                for their wealth.{" "}
              </p>
            </article>
          </div>
        </div>
      </DarkSection>
    </>
  );
};
